export const DEFAULT_LABELS = {
	contact_name: 'Brand Contact Name',
	contact_email: 'Brand Contact Email',
	contact_phone: 'Brand Contact Phone Number',
	contact_title: 'Brand Contact Title',
	sample_name: 'Request Sample Contact Name',
	sample_email: 'Request Sample Contact Email',
	sample_phone: 'Request Sample Contact Phone Number',
	sample_title: 'Request Sample Contact Title',
	haveABroker: 'Do you have a broker?'
};
